module.exports = __webpack_public_path__ + "static/media/creator.50628c3d.svg";